import React from 'react';
import { Col, Layout, Row } from 'antd';
import { Select } from 'components';
import './style.scss';
import { useLang } from '../PlayerRegistration';

const LANGUAGES_OPTIONS = [
  { label: 'English', value: 'en' },
  { label: 'Spanish', value: 'es' },
];

export const Step0 = () => {
  const { t } = useLang();

  return (
    <Layout className="team-registration__step-0">
      <Row>
        <Col sm={{ span: 24 }} md={{ flex: '224px' }}>
          <Select
            name="language"
            label={t('label_language')}
            rules={[{ required: true, message: t('error_language') }]}
            options={LANGUAGES_OPTIONS}
          />
        </Col>
      </Row>
    </Layout>
  );
};
